import React from "react";
import Header from "@/components/th/Header";
import Menu from "@/components/th/Menu";
import Footer from "@/components/th/Footer";
import MainProcess from "@/components/th/MainProcess";
import MainStep from "@/components/th/MainStep";
import NewsList from "@/components/th/NewsList";
import FloatingButton from "@/components/th/FloatingButton";
import ScrollToTopFab from "@/components/th/ScrollToTopFab";
import EmblaCarousel from "@/components/th/EmblaCarousel";
import { EmblaOptionsType } from "embla-carousel-react";
import Link from "next/link";
import Button from "@mui/material/Button";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CircleIcon from "@mui/icons-material/Circle";
import Stack from "@mui/material/Stack";
import Image from "next/image";
import SAbout from "@/public/static/images/opacity_about.png";
import SComNet from "@/public/static/images/opacity_company_network.png";
import SContact from "@/public/static/images/opacity_contact.png";

const OPTIONS: EmblaOptionsType = { loop: true };
// const SLIDE_COUNT = 1;
// const SLIDES = Array.from(Array(SLIDE_COUNT).keys());
function index({ banner, news }: any) {
  const SLIDE_DATA = banner.data;
  const SLIDE_COUNT = banner.total;
  const SLIDES = Array.from(Array(SLIDE_COUNT).keys());
  const NEWS_DATA = news.data;
  return (
    <div className="wrapper">
      <Header />
      <Menu />
      <section className="carousel">
        <EmblaCarousel slides={SLIDES} options={OPTIONS} data={SLIDE_DATA} />
      </section>
      <section className="content">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="heading">
                <h1 className="heading_inner fw-bold text-center mb-4">
                  แนะนำ
                  <CircleIcon
                    sx={{ mx: 2, fontSize: "14px", color: "#0179CC" }}
                  />
                  <span className="t-blue">ผลิตภัณฑ์ </span>
                </h1>
              </div>
            </div>
            <div className="col-12 mb-5">
              <MainProcess />
            </div>
          </div>
        </div>
        <div className="step_main py-5 mb-5">
          <div className="container">
            <div className="row">
              <div className="col-12 mt-2 mb-4">
                <div className="heading">
                  <h1 className="heading_inner fw-bold text-center mb-4">
                    การผลิตแบบครบวงจร<span className="t-blue">คุณภาพสูง</span>
                  </h1>
                </div>
                <div className="step_text text-center">
                  <ul className="justify-content-center ">
                    <li>
                      จุดแข็งของเราคือการทำงานภายในบริษัท ทั้งงานด้าน ปั๊มโลหะ,
                      เครื่องจักร และ งานอโนไดซ์
                    </li>
                    <li> เราทำงานเกี่ยวกับอลูมิเนียมและสแตนเลสเป็นหลัก</li>
                    <li>
                      นอกจากนี้เรายังทำเกี่ยวกับงานที่มีกระบวนการผลิตขั้นตอนเดียวด้วย
                    </li>
                    <li>
                      เราไม่เพียงแต่ผลิตสินค้าจำนวนมากแต่เรายังทำแผนงานจากการทดลองการผลิตสินค้าจำนวนมาก
                    </li>
                    <li>
                      เราสามารถดำเนินการทำงานได้โดยโรงงานสาขาประเทศไทย
                      ประเทศญี่ปุ่น และประเทศจีน
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 mb-4">
                <div className="Subheading">
                  <h2 className="subheading_inner text-center mb-4">
                    คำแนะนำเบื้องต้น
                  </h2>
                </div>
              </div>
              <div className="col-12">
                <MainStep />
                <div className="col-12 my-5 text-center">
                  <Link href="/th/instrument" className="btn-link">
                    <Button
                      variant="contained"
                      endIcon={<KeyboardArrowRightIcon />}
                    >
                      ดูเพิ่มเติม
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="heading-news">
                <div className="hstack gap-3 heading-news_inner">
                  <div className="heading-sub">
                    <h4 className="fw-bold mb-0">
                      ข่าว<span className="t-blue">สาร</span>
                    </h4>
                  </div>
                  <div className="ms-auto">
                    <Link className="link-normal" href="/th/news">
                      ดูเพิ่มเติม
                      <KeyboardArrowRightIcon />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 mb-5">
              <NewsList data={NEWS_DATA} />
            </div>
          </div>
        </div>
      </section>
      <section className="sub-contact">
        <div className="sub-contact-inner">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 0, sm: 0, md: 0 }}
            justifyContent="center"
            alignItems="center"
          >
            <Link href="/th/aboutus">
              <div className="card card-subcontact bg-darkblue">
                <Image loading="lazy"
                  src={SAbout}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">ประวัติบริษัท</h1>
                </div>
              </div>
            </Link>
            <Link href="/th/companynetwork">
              <div className="card card-subcontact bg-blue">
                <Image loading="lazy"
                  src={SComNet}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">บริษัทในเครือ</h1>
                </div>
              </div>
            </Link>
            <Link href="/th/contactus">
              <div className="card card-subcontact bg-darkblue">
                <Image loading="lazy"
                  src={SContact}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">ติดต่อสอบถาม</h1>
                </div>
              </div>
            </Link>
          </Stack>
        </div>
      </section>
      <FloatingButton />
      <ScrollToTopFab />
      <Footer />
    </div>
  );
}

export async function getServerSideProps(context: any) {
  const url = process.env.NEXT_PUBLIC_BASE_URL_API;

  let banner = await fetch(`${url}/v1/banner/th`).then((response) => {
    
    if (response.ok) {
      return response.json();
    }
    
    return Promise.reject(response); 
  }).catch((error) => {
   
  });

  if(!banner){
    banner = { data: []}
  }

  let news = await fetch(`${url}/v1/news/th`).then((response) => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject(response); 
  }).catch((error) => {
    console.log(error)
  });

  if(!news){
    news = { data: []}
  }

  return {
    props: {
      banner: {
        total: banner.data.length,
        data: banner.data,
      },
      news: {
        total: news.data.length,
        data: news.data,
      },
    },
  };
}
export default index;
